import { Name as EntityName } from '../../../../core/entity';

const SELECTOR_PREFIX = `${EntityName.SELECTOR_PREFIX}PLANNER:`;

export const EXECUTION = `${SELECTOR_PREFIX}execution`;
